<div *ngIf='payment() as payment'>
  <app-accordion-group>
    <app-accordion-item
      *ngFor='let occupation of payment.roadOccupations'
      [name]='occupation.name + " [" + (calcTotalStageCost(occupation) | currency) + "]"'
      [expanded]='expanded'>
      <ng-container *ngFor='let stage of occupation.stages'>
        <div class='col-12 d-flex justify-content-between'>
          <strong>
            {{ stage.name }}
          </strong>
          <app-label [label]='"Okres:"'>
            {{ stage.start | date }}&nbsp;-&nbsp;{{ stage.end | date }}
          </app-label>
          <app-label label='Liczba dni:'>
            {{ stage.daysCount }}
          </app-label>
        </div>
        <table class='table table-silver'>
          <thead>
          <tr>
            <th>
              Nazwa powierzchni
            </th>
            <th>
              Powierzchnia
            </th>
            <th>
              Stawka
            </th>
            <th>
              Kwota brutto
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor='let row of getCostPositions(stage)'>
            <td>
              {{ row?.surfaceName || '-' }}
            </td>
            <td>
              {{ row?.area | toNumber | number }}
            </td>
            <td>
              {{ row?.unitCost | toNumber | currency }}
            </td>
            <td>
              {{ row?.totalCost | toNumber | currency }}
            </td>
          </tr>
          </tbody>
          <tfoot *ngIf='!getCostPositions(stage).length'>
          <tr>
            <td colspan='4' class='no-data'>
              brak danych
            </td>
          </tr>
          </tfoot>
        </table>
        <br>
      </ng-container>
    </app-accordion-item>
  </app-accordion-group>
  <br>
  <app-label label='Łączny koszt prognozowanej opłaty:'>{{ payment.totalCost }} PLN</app-label>
</div>
<br>
